import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { erweiterteSuchenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface ErweiterteSuche {
    nr: number;
    text: string;
}

export const defaultErweiterteSuche: ErweiterteSuche = {
    nr: 0,
    text: '',
};

export function useErweiterteSuchenAsOptions(addEmpty = false): SelectOption[] {
    const erweiterteSuchen = useSelector(erweiterteSuchenSelector);
    return React.useMemo<SelectOption[]>(() => {
        const list = erweiterteSuchen.map(
            (erweitertesuche) =>
                ({ value: erweitertesuche.nr.toString(), label: erweitertesuche.text } as SelectOption),
        );
        if (addEmpty) {
            list.push({ value: '-1', label: '(keine Eintrag)' });
        }
        return list;
    }, [erweiterteSuchen, addEmpty]);
}

export async function addErweiterteSuche(erweiterteSuche: ErweiterteSuche): Promise<void> {
    return callApi<void>(Controller.erweiterteSuche + '/add', { erweiterteSuche });
}

export async function updateErweiterteSuche(erweiterteSuche: ErweiterteSuche): Promise<void> {
    return callApi<void>(Controller.erweiterteSuche + '/update', { erweiterteSuche });
}

export async function deleteErweiterteSuche(erweiterteSuche: ErweiterteSuche): Promise<void> {
    return callApi<void>(Controller.erweiterteSuche + '/update', { erweiterteSuche });
}
